<template>
  <div class="bottom">
    <div class="content">
      <div class="top">
        <div class="left">
          <div>
            <img src="@/assets/img/app.png" alt="" />
            <span>扫码下载药匣子APP</span>
          </div>
          <div>
            <img src="@/assets/img/docer.png" alt="" />
            <span>医生扫码关注药匣子</span>
          </div>
          <div>
            <img src="@/assets/img/pater.png" alt="" />
            <span>患者关注药匣子在线</span>
          </div>
        </div>
        <div class="tel">
          <span>联系电话</span>
          <a href="tel:4000520120" class="number">4000-520-120</a>
        </div>
      </div>
      <div class="middle">
        <div class="infoItem">
          <div class="infoTitle">公司地址</div>
          <div class="infoContent">
            北京市朝阳区管庄周家井大院内世通大厦C座6层601号
          </div>
        </div>
        <div class="infoItem mail">
          <div class="infoTitle">企业邮箱</div>
          <div class="infoContent">service@tcmbox.cn</div>
        </div>
        <div class="infoItem">
          <div class="infoTitle">备案号</div>
          <div class="infoContent icp">
            <span @click="icp">京ICP备14019419号</span>&nbsp;
            <span @click="dxyw">京B2-20170918</span>
          </div>
        </div>
      </div>
      <div class="otherInfo">
        <div class="copyRight">Copyright©北京益方鼎科技有限公司</div>
        <div class="last" @click="xkz">
          药品医疗器械网络信息服务备案 &nbsp;&nbsp;(京)网药械信息备字（2023）第00474号
        </div>
      </div>
      <div class="netPoliceInfo">
        <img class="netPoliceIcon" src="@/assets/img/netPolice.png" alt="" />
        <a
          style="margin-left: 4px;color:#999;"
          href="https://beian.mps.gov.cn/#/query/webSearch?code=11010502053553"
          rel="noreferrer"
          target="_blank"
          >京公网安备11010502053553</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "bottomNav",
  methods: {
    dxyw() {
      window.open("https://tsm.miit.gov.cn/dxxzsp/");
      // location.href = 'https://tsm.miit.gov.cn/dxxzsp/'
    },
    icp() {
      window.open("https://beian.miit.gov.cn/");
      // location.href = 'http://www.beian.miit.gov.cn/'
    },
    xkz() {
      window.open("http://yjj.beijing.gov.cn/");
      // location.href = 'http://yjj.beijing.gov.cn/'
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styles/varibles.styl'

.bottom
  width 100%
  height 396px
  display flex
  flex-direction column
  justify-content center
  align-items center
  position relative
  background #303030

  .content
    width 1280px
    height 100%

    .top
      width 100%
      display flex
      flex-direction row
      justify-content space-between
      align-items center
      margin-top 38px

      .left
        display flex
        flex-direction row
        justify-content center
        align-items center
        margin-left 65px

        div
          display flex
          flex-direction column
          justify-content center
          align-items center
          margin 0 25px

          img
            width 148px

          span
            font-size 16px
            color white

      .tel
        margin-right 90px

        span
          color white
          font-size 14px

        .number
          color white
          font-size 30px
          margin-left 10px

    .middle
      width 100%
      display flex
      flex-direction row
      justify-content center
      align-items center
      margin-top 60px

      .infoItem
        display flex
        flex-direction row
        justify-content center
        align-items center
        padding 0 80px
        box-sizing border-box
        font-size 0.1867rem
        color white
        line-height 1.1

        .infoContent
          margin-left 10px

        .icp
          cursor pointer

      .mail
        border-left 2px solid white
        border-right 2px solid white

    .otherInfo
      text-align center
      color #999999
      font-size 14px
      margin-top 24px
      line-height 18px

      .last
        cursor pointer
        margin-top 6px

@media screen and (max-width 1279px)
  .bottom
    width 100%
    height auto

    .content
      width 100%

      .top
        margin-top 0.1333rem
        flex-direction column

        .left
          flex-direction row
          margin 0

          div
            margin 0 0.2rem
            margin-top 0.2667rem

            img
              width 2.4rem

            span
              font-size 0.32rem
              margin-top 0.1333rem
              text-align center

        .tel
          margin 0
          font-size 0.3733rem
          margin-top 0.0667rem

          .number
            font-size 0.4267rem

      .middle
        margin-top 0.0667rem
        flex-direction column

        .infoItem
          padding 0
          border none
          margin-top 0.1333rem

      .otherInfo
        margin-top 0.1333rem
        font-size 0.1867rem
        padding-bottom 0.1333rem

        div
          margin-top 0.0667rem

        .last
          margin-top 0.0667rem
.netPoliceInfo{
  display: flex
  flex-direction: row
  justify-content: center
  align-items: center
  color: #999
  margin 6px 0
}
.netPoliceIcon{
  width: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/Homepage/components/Bottom.vue